
// バックエンドからの変数はnotify_count,notify_dataに保持しています。
// ユーザー名とチーム名はJetstreamのテーブルの値を使用しています。

<template>

  <!-- gnav: GlovalNAVication 全ページに共通のナビゲーションヘッダ -->
  <nav class="gnav">
    <!-- gnav左寄せの内容 -->
    <div class='left-item-group'>

      <!-- メニュー表示用ボタン -->
      <input id="menu__toggle" type="checkbox" @click="on_sidebar" />
      <label class="menu__hamburger-btn" for="menu__toggle">
        <img class="menu__hamburger-icon" src="/img/04_hamburger.svg"/>
      </label>

      <!-- サイドバー表示時のオーバーレイ -->
      <label class="overlay"  for="menu__toggle"></label>
      <!-- サイドバー -->
      <ul class="sidebar" v-bind:class="{mv_r : is_sidebar}">
        <li><Link class="sidebar__item" :href="route('file_translate.index')" @click="guardTeamNavigation"> ファイル翻訳 </Link></li>
        <li><Link class="sidebar__item" :href="route('text_translate.index')" @click="guardTeamNavigation"> テキスト翻訳 </Link></li>
        <li><Link class="sidebar__item" :href="route('video_translate.create')" @click="guardTeamNavigation"> 動画翻訳 </Link></li>
        <hr>
        <li><Link class="sidebar__item" :href="route('translated_bilingual_files.index')" @click="guardTeamNavigation"> 対訳ファイル一覧 </Link></li>
        <li v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'" >
          <Link class="sidebar__item" :href="route('translated_bilingual_files.archivedIndex')" @click="guardTeamNavigation"> アーカイブ </Link>
        </li>
        <li><Link class="sidebar__item" :href="route('video_translate.index')" @click="guardTeamNavigation"> 動画翻訳一覧 </Link></li>
        <li v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'" >
          <Link class="sidebar__item" :href="route('video_translate.archived_index')" @click="guardTeamNavigation"> 動画アーカイブ </Link>
        </li>
        <li><Link class="sidebar__item" :href="route('glossaries.index')" @click="guardTeamNavigation"> 用語集 </Link></li>
        <li><Link class="sidebar__item" :href="route('inquiries.create')"> お問い合わせ </Link></li>
 
        <!-- 管理権限所有者用メニュー -->
        <div v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'">
          <hr>
          <li class="sidebar__item--head"> 管理メニュー </li>
          <li><Link class="sidebar__item" :href="route('users.index')"> ユーザー管理 </Link></li>
          <li><Link class="sidebar__item" :href="route('management.teams.index')"> チーム管理 </Link></li>
          <li  v-if="$page.props.permission == 'オーナー'"><Link class="sidebar__item" :href="route('contracts.index')"> 契約管理 </Link></li>
        </div>
      </ul>

      <!-- JVTAのロゴ: ファイル翻訳へ繊維 -->
      <Link :href="route('file_translate.index')" @click="guardTeamNavigation">
      <div class="jvta-logo">
        <img src="/img/04_JVTA_Online_logo_B.png" alt="logo_menu" class="jvta-logo-img"/>
      </div>
      <!--
        <svg class="jvta-logo">
          <use xlink:href="/img/04_JVTA_Online_logo_B.svg#レイヤー_1"></use>
        </svg>
        -->
      </Link>

    </div>

    <!-- gnav右寄せの内容 -->
    <div class='right-item-group'>

      <!-- チームドロップダウンメニュー -->
      <div class="dropdown">
        <input id="dropdown-toggle--team" type="checkbox" v-model="showTeamDropdown"/>
        <label id="dropdown-btn--team" class="dropdown__btn" for="dropdown-toggle--team">
          <div class="dropdown__btn-text"> {{$page.props.user.current_team == null ? 'なし' : $page.props.user.current_team.name}} </div>
          <svg class="dropdown__btn-vdots">
            <use xlink:href="/img/vdots.svg#_x32_"></use>
          </svg>
        </label>
        <ul id="dropdown__list--team" class="dropdown__list">
          <li class="dropdown__item--head">チームを変更する</li>
          <li class="dropdown__item" v-for="team in $page.props.user.all_teams" @click="switchTeam(team)"> {{team.name}} </li>
          <hr>
          <div v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'">
            <li class="dropdown__item--head">チーム管理</li>
            <li> <Link class="dropdown__item" :href="route('management.teams.index')"> チームの設定 </Link> </li>
          </div>
        </ul>
      </div>

      <!-- ユーザードロップダウンメニュー -->
      <div class="dropdown">
        <input id="dropdown-toggle--user" type="checkbox" v-model="showUserDropdown" />
        <label id="dropdown-btn--user" class="dropdown__btn" for="dropdown-toggle--user">
          <div class="dropdown__btn-text">  {{ $page.props.user.name }} </div>
          <svg class="dropdown__btn-vdots">
            <use xlink:href="/img/vdots.svg#_x32_"></use>
          </svg>
        </label>
        <ul id="dropdown__list--user" class="dropdown__list">
          <li class="dropdown__item--head">アカウント管理</li>
          <li> <Link class="dropdown__item" :href="route('useredit')"> プロフィール </Link> </li>
        </ul>
      </div>

      <!-- 通知アイコン -->
      <button class="notif__btn" @click="openNotificationIndexModal">
        <div v-if="$page.props.messages.length > 0">
          <img class="notif__icon" src="/img/04_notification.svg" alt=""/>
          <span class="notif__icon-badge" v-if="$page.props.unread_cnt > 0">
            {{$page.props.unread_cnt}}
          </span>
        </div>
        <div v-else>
          <img class="notif__icon--no-unread" src="/img/04_notification.svg" alt=""/>
        </div>
      </button>

      <!--ログアウトボタン -->
      <button class="logout__btn" @click="logout">
        <img class="logout__svg" src="/img/04_logout.svg" alt="logout_menu"/>
      </button>

    </div>
  </nav>


  <!-- notif-idx-mdl: 通知の一覧表示用モーダル -->
  <modal class="notif-idx-mdl" ref="notificationIndexModal">
    <template v-slot:modalTitle> 通知一覧 </template>
    <template v-slot:modal-content="{ closeModal }">
      <div class="notif-table">

        <div class="notif-table-head">
        
          未読: {{$page.props.unread_cnt}} 件
        </div>

        <table class="component_table notif-table">
          <thead>
            <tr>
              <th class="notif-table__th--date"> 送信日時 </th>
              <th class="notif-table__th--contents"> タイトル </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in $page.props.messages">
              <td class="text-center"> {{message.scheduled_at}} </td>
              <td class="notif-table__td--contents" @click="openNotificationDetailModal(message)">
                <span class="contents-td__tag--unread rounded" v-if="message.is_unread">未読</span>
                <span class="contents-td__tag--important rounded" v-if="message.is_important">重要</span>
                <b class="text-decoration-underline contents-td__tag"> {{message.title}} </b>
                <!-- <span> - </span> -->
                <!-- {{message.text}} -->
              </td>
            </tr>
          </tbody>
        </table>


      </div>
    </template>
  </modal>

  <!-- notif-dtl-mdl: 通知の詳細表示用モーダル -->
  <modal class="notif-dtl-mdl" ref="notificationDetailModal">
    <template v-slot:modalTitle> 通知詳細 </template>
    <template v-slot:modal-content="{ closeModal }">
      <div class="msg-group">

        <div class="msg__section">
          <span> 件名: </span>
          <h4>
            <b> {{openedMessage.title}} </b> 
            <span v-if="openedMessage.is_important"> - </span>
            <span class="contents-td__tag--important rounded" v-if="openedMessage.is_important">重要</span>
          </h4>
        </div>

        <div class="msg__section">
          <span> 通知日時: </span>
          <h5>
            {{openedMessage.scheduled_at}} 
          </h5>
        </div>

        <div class="msg__section">
          <span> 本文: </span>
          <div class="msg__panel" style="white-space: pre-wrap;">
            {{openedMessage.text}} 
          </div>
        </div>

        <div class="msg__foot">
          <button class="btn btn-purple" @click="leaveNotificationDetailModal">戻る</button>
        </div>
      
      </div>

    </template>
  </modal>

</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import { usePage } from '@inertiajs/inertia-vue3';
import { defineComponent } from 'vue';
import JetDropdown from '@/Jetstream/Dropdown.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
import JetNavLink from '@/Jetstream/NavLink.vue';
import modal from "@/Pages/Components/modal.vue";

export default defineComponent({
  components: {
    Link,
    modal, 
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
  },
  name: 'Props',
  data() {
    return {
      selectedMessages: [],
      openedMessage: Object, //詳細モーダルで表示するメッセージ
      is_sidebar: false,
      showTeamDropdown: false,
      showUserDropdown: false,
    };
  },
  computed: {
    notify_counter() {
      return {
        '--notify_count': this.notify_count,
      };
    },
  },
  methods: {
    showProps(){
      console.log(this.props);
    },
    switchTeam(team) {
      this.$inertia.put(
        route('current-team.update'),
        {team_id: team.id},
        {preserveState: false,
          onSuccess:()=>{
          },
          onError:(e)=>{
            alert(e.error_message);
          }
        }
      );
    },
    on_sidebar(){
      if(this.is_sidebar){
        this.is_sidebar=false
      }else{
        this.is_sidebar=true
      }
    },
    logout() {
      if (confirm('ログアウトします。よろしいですか？')){
        this.$inertia.post(route('logout'));
      }
    },
    openNotificationIndexModal(){
      this.$refs.notificationIndexModal.openModal({is_wide: true, is_long: true});
    },
    openNotificationDetailModal(message){
      this.openedMessage = message;
      this.$refs.notificationIndexModal.closeModal();
      this.$refs.notificationDetailModal.openModal({is_wide: true});      
      this.postIsreadStatus(message);  
    },
    leaveNotificationDetailModal(){
      this.$refs.notificationDetailModal.closeModal();
      this.$refs.notificationIndexModal.openModal({is_wide: true, is_long: true});
    },
    postIsreadStatus(message) {
      axios
        .post(this.route('message.isread', message.id), {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-CSRF-TOKEN': this.csrf_token
          }
        })
        .then(response => {
          if (response.status === 200) {
            for (let i = 0; i < usePage().props.value.messages.length; ++i) {
              if (usePage().props.value.messages[i].id == message.id) {
                if ( usePage().props.value.messages[i].is_unread == 1 ) {
                  usePage().props.value.messages[i].is_unread = 0;
                  --usePage().props.value.unread_cnt;
                }
              }
            }
          }
        })
        .catch(error => {
          if (error.response.status === 400 || error.response.status === 422) {
            alert(error.response.data.message)
          }
        });
    },
    guardTeamNavigation(event){
      if (this.hasCurrentTeam()) {
        return;
      }

      event.preventDefault();
      this.showTeamAlert(true);
    },
    showTeamAlert(force = false){
      const pages = usePage();
      if (pages.url.value.includes('teams')){
        return;
      }

      if (this.hasCurrentTeam()){
        return;
      }

      if (!force && !this.currentPageNeedsTeam()) {
        return;
      }

      if (this.canManageTeams()){
        const confirmed = confirm(this.teamRequiredMessage());
        if (confirmed){
          this.$inertia.visit(this.route("management.teams.index"));
        }
      } else {
        alert(this.teamRequiredMessage());
      }
    },
    hasCurrentTeam(){
      const user = usePage().props.value.user;
      return !!(user && user.current_team);
    },
    canManageTeams(){
      const permission = usePage().props.value.permission;
      return permission === 'オーナー' || permission === 'マネージャー';
    },
    currentPageNeedsTeam(){
      const url = usePage().url.value;
      return [
        '/translate',
        '/file_translate',
        '/text_translate',
        '/translated_bilingual_files',
        '/translated_bilingual_file',
        '/glossaries',
      ].some((path) => url.startsWith(path));
    },
    teamRequiredMessage(){
      return usePage().props.value.flash?.team_required_message
        || "ログインしているユーザーは、現在のチームが選択されていません。\n右上の'なし'をクリックしチームを選択してください。\n所属チームがない場合マネージャーにチームへの追加を依頼してください。";
    },
  },
  mounted: function(){
    window.addEventListener('mouseup', function(event){

      // ドロップダウンリストの外を押されたときに、閉じる
      // あまり良くない実装なので、時間があれば修正する
      var teamDropList = document.getElementById('dropdown__list--team');
      var teamDropBtn = document.getElementById('dropdown-btn--team');
      if (event.target != teamDropList
        && event.target.parentNode != teamDropList
        && event.target !=teamDropBtn 
        && event.target.parentNode !=teamDropBtn
      ){
        document.getElementById('dropdown-toggle--team').checked = false;
      }

      var userDropList = document.getElementById('dropdown__list--user');
      var userDropBtn = document.getElementById('dropdown-btn--user');
      if (event.target != userDropList
        && event.target.parentNode != userDropList
        && event.target !=userDropBtn 
        && event.target.parentNode !=userDropBtn
      ){
        document.getElementById('dropdown-toggle--user').checked = false;
      }
    });
    this.showTeamAlert();
  },
});
</script>

<style lang="scss" scoped>
$modal_bg: #fffbf9;
$over_modal_bg: #999999;
$table_cel_font: #666666;
$menu_bg: #31343d;
$menu_font_color: #dcdcdc;
$dropdown_bg: #fffbf9;

// メニューバーの表示に関するスタイル
.gnav {
  z-index:3;

  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #31343d;
  position:fixed;
  top:0;
  width: 100%;
}

// メニューバーの左側のアイテム（メニューアイコン、JVTAロゴ）
.left-item-group {
  display: flex;
  justify-content: start;
  align-items: center;
}

// メニューボタンの表示に関する要素
#menu__toggle{display: none;}
// #menu__toggle:checked ~ .sidebar {
//   left: 0 !important;
// }
.mv_r {
  left: 0 !important;
}
#menu__toggle:checked ~ .overlay {
  visibility: visible;
  opacity: 1;
}
.menu__hamburger-btn {
  cursor: pointer;
  z-index: 3;
}
.menu__hamburger-icon {
  padding: 0 0.5rem 0 0;
  height: 2.5rem;
}

.overlay{
	z-index:1;
	display:block;
  visibility: hidden;
  opacity: 0;
	position:fixed;
	width:100%;
	height:120%;
	top:4rem;
	left:0;
	background-color:rgba(0,0,0,0.75);
  transition: .25s;
}

// サイドバーに関するスタイル
.sidebar {
  z-index: 2;
  display: block;
  position: fixed;
  top: 4rem;
  left: -100%;
  width: 250px;
  height: 100%;
  overflow-y : auto;
  margin: 0;
  padding: 1rem 0 6rem 0;
  list-style: none;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  transition-duration: .25s;
  // background-color: #ECEFF1;
  background-color: #31343d;
  hr{color: #949494}
}
.sidebar__item {
  display: block;
  padding: 12px 24px;
  color: white;
  text-decoration: none;
}
.sidebar__item--head {
  font-size: small;
  display: block;
  padding: 6px 24px;
  color: #949494;
  text-decoration: none;
  transition-duration: .25s;
}

.sidebar__item:hover {
  background-color: #202225;
}

.jvta-logo-img{
  height: 2rem;
  width: auto;
}

.jvta-logo{
  padding: 0.5rem;
}


// メニューバーの右側のアイテム（現在のチーム名、ユーザ名、通知アイコン、設定アイコン、ログアウトボタン）
.right-item-group {
  display: flex;
  justify-content: end;
  align-items: center;
}

// ドロップダウン
.dropdown {
  height: 2rem;
  margin: 0 0.5rem;
  position: relative;
  transition: all .3s;
}
// ドロップダウンボタン
.dropdown__btn{
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;

  font-size: 1rem;
  height: 2rem;
  // width: 10rem;
  cursor: pointer;
  color: white;
  border: solid $menu_font_color 1px;
  background: $menu_bg;
  border-radius: 100vh;
  color: $menu_font_color;
  vertical-align: middle;
}
.dropdown__btn:hover {
    background-color: #202225;
}
.dropdown__btn-text{
  padding: 0 1rem;
}
.dropdown__btn-vdots{
  fill: #dcdcdc;
  height: 1rem;
  width: 2rem;
}

#dropdown-toggle--team{display: none;}
#dropdown-toggle--team:checked ~ #dropdown__list--team {
  visibility: visible;
  opacity: 1;
}
#dropdown-toggle--user{display: none;}
#dropdown-toggle--user:checked ~ #dropdown__list--user {
  visibility: visible;
  opacity: 1;
}

// リストの書式
.dropdown__list {
  z-index: 1;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  // default: 非表示
  visibility: hidden; 
  opacity: 0;
  transition: all .25s;  width: 100%;
  list-style: none;
  position: relative;
  top: 0.5rem;
  margin:0;
  padding:0;
  background-color: #31343d;
  hr{
    color: #949494;
    margin: 0.5rem 0;
  }
}

.dropdown__item {
  cursor: pointer;
  display: block;
  height: 2rem;
  padding: 0 0 0 1rem;

  display: flex;
  align-items: center;
  text-align: center;
  
  text-decoration: none;
  color: white;

  transition-duration: .25s;
  position: relative;
}

.dropdown__item:hover {
  background-color: #202225;
}

.dropdown__item--head {
  font-size: small;
  color: #949494;
  display: block;
  height: 2rem;
  padding: 0 0 0 1rem;

  display: flex;
  align-items: center;
  text-align: center;
  
  text-decoration: none;
  transition-duration: .1s;
  position: relative;
}

// 通知アイコン
.notif__btn{
  border: none;
  background: transparent;
}
.notif__icon{
  height: 2rem;
  position: relative;
  left:0.5rem;
}
.notif__icon--no-unread{
  height: 2rem;
  margin:0 1rem;
}
.notif__icon-badge{
  padding:2px 3px;
  background-color: red;
  font-size: 12px;
  color: white;
  text-align: center;
  border: solid;
  border-radius: 100vh;
  border-color: #31343d;
  position: relative;
  right:0.5rem;
  top:-0.5rem;
}

// ログアウトボタン
.logout__btn{
  margin: 0 0 0 1rem;
  border: none;
  background: transparent;
}
.logout__svg{
  height: 2rem;
}

// #[Modal Window]#############################################################//
// .notif-idx-mdl{
//   width: 75%;
// }
.notif-table-head{
  margin: 1rem 0;
  text-align: end;
}
.notif-table{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.notif-table__th--contents{
  // width: 70%
  text-align: center;
  height: 2.5rem;
}
.notif-table__th--date{
  width: 7rem;
  text-align: center;
}
.notif-table__th--checkbox{
  width: 3rem;
  text-align: center;
}

.notif-table__td--contents{
  cursor: pointer;
  text-align:left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  span{padding: 0 0.5rem}
  height: 2.5rem;
  padding:0.5rem;
}

.contents-td__tag--unread {
  background-color: #9966cc;
  color: white;
  font-weight: normal;
  padding: 2px 4px;
  margin-left: 0.8rem;
}

.contents-td__tag--important {
  background-color: #ff6666;
  color: white;
  font-weight: normal;
  padding: 2px 3px;
  margin-left: 0.8rem;
}


.notif-table-foot{
  margin: 1rem 0;
  text-align: end;
}

//# [通知詳細モーダル] ####################################################################//
.msg-group{
  padding: 0 2rem;
}
.msg__section{
  margin: 1rem 0;
  text-align: start;
}

.msg__panel {
  height: 40vh;
  overflow-y: scroll;
  width: 100%;
  padding: 1rem;
  // margin: auto;
  overflow-wrap: break-word;
  border: 1px solid;
  border-radius: 10px;
  // padding-left: 15px;
  // padding-right: 15px;
  color: #666666;
  background-color: #ffffff;
  // white-space: nowrap; /*　（全角+半角）の文字で改行しないように */
}

.msg__foot{
  margin: 1rem 0;
  text-align: center;
}

.contents-td__tag{
  margin-left: 0.8rem;
}
// .meg__header { // 「件名:」、「通知日時:」 ...など

// }
</style>
